namespace $.$$ {

	$mol_style_define( $shm_projects_task, {
		Details_page: {
			flex: { basis: '30rem', grow: 0, shrink: 0 },
			width: '30rem',
			minWidth: 0,
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
		},
		Editor: {
			flex: { direction: 'column' },
		},
		Summary: {
			flex: { direction: 'column' },
		},
		Task_meta: {
			flex: { direction: 'column' },
		},
		Editor_actions: {
			flexWrap: 'wrap',
			gap: 0,
		},
		Description_field: {
			padding: { top: $mol_gap.block, bottom: $mol_gap.block },
		},
		Summary_actions: {
			flexWrap: 'wrap',
			gap: $mol_gap.text,
		},
		Description_card: {
			padding: { top: $mol_gap.block, bottom: $mol_gap.block },
		},
		Result_card: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},
		Result_title: {
			font: { weight: 'bold' },
		},
	} )

}
